export enum DocumentComponentName {
  SupplierOfferLegalTerms = 4,
  SupplierOffer = 5

}
